import { render, staticRenderFns } from "./CuponDescuentoComponent.vue?vue&type=template&id=4a0aacee"
import script from "./CuponDescuentoComponent.vue?vue&type=script&lang=js"
export * from "./CuponDescuentoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports